export default [
  {
    icon: "ios-leaf",
    name: "trees",
    title: "古树管理",
    children: [
      {
        title: "古树列表",
        route: "/trees/trees/list"
      },
      {
        title: "古树树种",
        route: "/trees/treeTypes/list"
      },
      {
        title: "古树科属",
        route: "/trees/trees/categories"
      },
      {
        title: "认养",
        route: "/trees/treeAdoptions/list"
      },
      {
        title: "许愿签",
        route: "/trees/treeWishes/list"
      },
      {
        title: "巡护",
        route: "/trees/treeNursings/list"
      }
    ]
  },
  {
    icon: "md-document",
    name: "about",
    title: "关于我们",
    children: [
      {
        title: "关于我们",
        route: "/about/aboutSettings/form"
      },
      {
        title: "单位荣誉",
        route: "/about/honours/list"
      }
    ]
  },
  {
    icon: "md-document",
    name: "news",
    title: "新闻动态",
    children: [
      {
        title: "新闻动态列表",
        route: "/news/articles/list"
      },
      {
        title: "新闻动态分类",
        route: "/news/articles/categories"
      }
    ]
  },
  {
    icon: "md-document",
    name: "policies",
    title: "政策法规",
    children: [
      {
        title: "政策法规列表",
        route: "/policies/articles/list"
      },
      {
        title: "政策法规分类",
        route: "/policies/articles/categories"
      }
    ]
  },
  {
    icon: "ios-text",
    name: "messages",
    title: "留言管理",
    children: [
      {
        title: "留言列表",
        route: "/messages/messages/list"
      }
    ]
  },
  {
    icon: "ios-settings",
    name: "website",
    title: "网站设置",
    children: [
      {
        title: "首页轮播图",
        route: "/website/ads/list"
      },
      {
        title: "网站设置",
        route: "/website/settings/form"
      }
    ]
  },
  {
    icon: "md-person",
    name: "users",
    title: "用户管理",
    children: [
      {
        title: "微信用户",
        route: "/users/wxUsers/list"
      },
      {
        title: "巡护人员",
        route: "/users/users/list"
      }
    ]
  }
];
